import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WarningModalComponent } from '../../../modals/warning-modal/warning-modal';
import { BusinessService } from '../business/business.service';
import { ModalDialogService } from '../modal-dialog/modal-dialog.service';
import { UserService } from '../user/user.service';

@Injectable()
export class BusinessCountGuard {
  constructor(
    protected router: Router,
    private userService: UserService,
    private businessService: BusinessService,
    private modalDialogService: ModalDialogService
  ) {}

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    const result =
      this.businessService.businessesLoaded &&
      this.userService.businesses.length === 0
        ? false
        : true;

    if (!result) {
      this.showWarningModal('INFORMATION', 'NO_BUSINESS_WARNING');
    }

    return result;
  }

  showWarningModal(title: string, message: string) {
    const warningModal = this.modalDialogService.showPopupReturn(
      WarningModalComponent,
      {
        title: title,
        message: message,
        hideCancel: true,
        button: 'CONFIRM'
      },
      'Warning',
      ModalSizeEnum.small
    );

    return warningModal;
  }
}
